
$(window).on('load', () => {
    (() => {
        $(document).ready(() => {
            $(document).on("swell:initialized", () => {
                console.log("swell:initialized");
                new RedemptionDiscount(swellAPI.getActiveRedemptionOptions()).renderRedemptionList();
                new ProductRedemptions(swellAPI.getActiveRedemptionOptions(), swellDef.redemptionsExclusions).renderRedemptionOptions();
                // vipContainer.renderVipTiers();
                new VipSection(swellAPI.getVipTiers()).renderVipTiers()
            });

            $(document).on("swell:setup", () => {
                console.log("swell:setup");
                new CampaignGrid(swellAPI.getActiveCampaigns()).renderCampaigns();
                //CampaignGrid.renderCampaignImage();
                VipSection.renderVipStatus(swellAPI.getCustomerDetails().vipTier, swellAPI.getVipTiers(), swellAPI.getCustomerDetails().email);

                //  new Header().renderHeader();
                //  new Campaign(spapi.activeCampaigns).CampaignLogin();
                // vipContainer.renderVipStatus(swellAPI.getCustomerDetails().vipTier, swellAPI.getVipTiers().slice(0, 2), swellAPI.getCustomerDetails().email);
                //  vipContainer.renderVipHeader(swellAPI.getCustomerDetails().vipTier);
                //  ProductRedemptions.greyButtonIfLoggedOut();
                spapi.initialize()
            });
        });
    }).call(this);
})